var _polygon, _polygon2, _rect, _rect2, _rect3, _path, _circle, _path2, _polygon3, _rect4, _circle2, _path3, _polygon4, _rect5, _circle3, _path4, _polygon5, _rect6, _circle4, _path5, _polygon6, _rect7, _path6, _circle5, _rect8, _path7, _circle6, _rect9, _path8, _circle7, _rect0, _path9, _circle8, _rect1, _path0, _circle9, _rect10, _path1, _circle0, _rect11, _path10, _circle1, _rect12, _path11, _circle10, _rect13, _path12, _circle11, _rect14, _path13, _circle12, _rect15, _path14, _circle13, _rect16, _path15, _circle14, _rect17, _path16, _circle15, _rect18, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle16, _path28, _path29, _circle17, _path30, _circle18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebDeveloper(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 885.86993,
    height: 622.8043,
    viewBox: "0 0 885.86993 622.8043",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "through_the_park") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "461.601 348.37 400.416 348.37 400.416 350.344 409.958 350.344 409.958 369.094 411.932 369.094 411.932 350.344 449.098 350.344 449.098 369.094 451.072 369.094 451.072 350.344 461.601 350.344 461.601 348.37",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "484.299 300.014 468.509 300.014 468.509 315.803 475.829 315.803 475.829 369.007 477.803 369.007 477.803 315.803 484.299 315.803 484.299 300.014",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 400.53636,
    y: 342.46486,
    width: 61.18538,
    height: 1.97372,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 400.53636,
    y: 337.53055,
    width: 61.18538,
    height: 1.97372,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 400.53636,
    y: 332.59625,
    width: 61.18538,
    height: 1.97372,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M775.57723,513.38047h-1.97372c0-93.59519-76.14539-169.7401-169.7401-169.7401-93.59518,0-169.74009,76.14491-169.74009,169.7401H432.1496c0-94.68325,77.03057-171.71382,171.71381-171.71382C698.54714,341.66665,775.57723,418.69722,775.57723,513.38047Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 161.35177,
    cy: 161.35177,
    r: 161.35177,
    fill: "#20378e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M438.4403,192.17931a161.36436,161.36436,0,0,1-268.85975,170.77,161.36567,161.36567,0,1,0,268.85975-170.77Z",
    transform: "translate(-157.06503 -138.59785)",
    opacity: 0.2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "161.795 161.352 162.238 161.352 170.217 618.811 153.373 618.811 161.795 161.352",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 329.05538,
    y: 537.54454,
    width: 7.97893,
    height: 30.14264,
    transform: "translate(509.8146 -138.12101) rotate(62.23413)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.27647,
    cy: 229.8063,
    r: 130.59346,
    fill: "#20378e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.48506,281.178a130.60365,130.60365,0,0,1-217.60732,138.2163A130.60471,130.60471,0,1,0,1009.48506,281.178Z",
    transform: "translate(-157.06503 -138.59785)",
    opacity: 0.2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "755.635 229.806 755.994 229.806 762.452 600.06 748.819 600.06 755.635 229.806",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 920.95206,
    y: 560.70661,
    width: 6.45792,
    height: 24.39658,
    transform: "translate(843.51724 -650.35577) rotate(62.23413)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 369.90725,
    cy: 321.70366,
    r: 20.55846,
    fill: "#20378e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M542.265,446.57008a20.56006,20.56006,0,0,1-34.25647,21.75847A20.56023,20.56023,0,1,0,542.265,446.57008Z",
    transform: "translate(-157.06503 -138.59785)",
    opacity: 0.2
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.964 321.704 370.02 321.704 371.037 379.99 368.891 379.99 369.964 321.704",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 528.32779,
    y: 490.57441,
    width: 1.01663,
    height: 3.84059,
    transform: "translate(561.19589 -343.48173) rotate(62.23413)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 559.878,
    cy: 255.44299,
    r: 52.63144,
    fill: "#20378e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M756.09357,358.88718A52.63554,52.63554,0,0,1,668.394,414.59075a52.636,52.636,0,1,0,87.69954-55.70357Z",
    transform: "translate(-157.06503 -138.59785)",
    opacity: 0.2
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "560.023 255.443 560.167 255.443 562.77 404.662 557.275 404.662 560.023 255.443",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 720.41323,
    y: 471.54209,
    width: 2.60265,
    height: 9.83225,
    transform: "translate(650.03004 -522.71764) rotate(62.23413)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M354.5881,734.63564s.68149-14.27971,14.65205-12.61989",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.57562,
    cy: 575.45671,
    r: 6.99217,
    fill: "#20378e"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 192.43789,
    y: 587.23109,
    width: 1.97372,
    height: 13.81605,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M403.93115,702.06922s.68149-14.27971,14.652-12.61988",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.91867,
    cy: 542.89029,
    r: 6.99217,
    fill: "#20378e"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 241.78094,
    y: 554.66468,
    width: 1.97372,
    height: 13.81605,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M552.67,591.58462s.54127-11.34162,11.63735-10.02331",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 392.46975,
    cy: 436.6403,
    r: 5.55351,
    fill: "#20378e"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 391.56611,
    y: 445.99208,
    width: 1.56762,
    height: 10.97337,
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M769.77945,556.05762s.54127-11.34162,11.63735-10.02331",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 609.57917,
    cy: 401.1133,
    r: 5.55351,
    fill: "#20378e"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 608.67553,
    y: 410.46508,
    width: 1.56762,
    height: 10.97337,
    fill: "#3f3d56"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M562.53864,621.19045s.54127-11.34163,11.63735-10.02331",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 402.33836,
    cy: 466.24613,
    r: 5.55351,
    fill: "#20378e"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 401.43472,
    y: 475.59791,
    width: 1.56762,
    height: 10.97337,
    fill: "#3f3d56"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M538.854,642.90139s.54127-11.34162,11.63735-10.02331",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.6537,
    cy: 487.95707,
    r: 5.55351,
    fill: "#20378e"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 377.75006,
    y: 497.30885,
    width: 1.56762,
    height: 10.97337,
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M803.33272,574.808s.54128-11.34162,11.63736-10.02331",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 643.13244,
    cy: 419.86366,
    r: 5.55351,
    fill: "#20378e"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 642.22881,
    y: 429.21544,
    width: 1.56762,
    height: 10.97337,
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M483.58976,599.47951s.54127-11.34163,11.63735-10.02332",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.38948,
    cy: 444.53519,
    r: 5.55351,
    fill: "#20378e"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 322.48584,
    y: 453.88696,
    width: 1.56762,
    height: 10.97337,
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M740.17362,543.22843s.54127-11.34162,11.63735-10.02331",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 579.97334,
    cy: 388.28411,
    r: 5.55351,
    fill: "#20378e"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 579.0697,
    y: 397.63589,
    width: 1.56762,
    height: 10.97337,
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M268.73119,737.59622s.68149-14.27971,14.652-12.61989",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.71872,
    cy: 578.41729,
    r: 6.99217,
    fill: "#20378e"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 106.58099,
    y: 590.19168,
    width: 1.97372,
    height: 13.81605,
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M948.67842,733.64878s.68149-14.27971,14.65205-12.61989",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 787.66594,
    cy: 574.46985,
    r: 6.99217,
    fill: "#20378e"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 786.52822,
    y: 586.24423,
    width: 1.97372,
    height: 13.81605,
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M891.44048,700.0955s.68149-14.27971,14.65205-12.61988",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 730.42801,
    cy: 540.91657,
    r: 6.99217,
    fill: "#20378e"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 729.29028,
    y: 552.69096,
    width: 1.97372,
    height: 13.81605,
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M883.54559,750.42541s.6815-14.27971,14.65205-12.61988",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.53312,
    cy: 591.24648,
    r: 6.99217,
    fill: "#20378e"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 721.39539,
    y: 603.02087,
    width: 1.97372,
    height: 13.81605,
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M280.09142,761.08258S590.95263,679.17311,587.992,595.28993c-5.42774-23.19124-42.92846-29.1124-42.92846-29.1124s-88.81749-11.84233-40.4613-40.4613,180.59557-21.71094,180.59557-21.71094-136.18682,21.71094-75.9883,33.55327c48.35619,2.96058,110.52843,15.78978,110.52843,15.78978S846.0562,579.99358,863.8197,645.12641s2.96058,115.46273,2.96058,115.46273Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M618.67289,761.40215l-1.16407-1.627q2.4668-1.76367,4.85938-3.50781l1.17773,1.61719Q621.14359,759.63213,618.67289,761.40215Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M633.18265,750.72832l-1.207-1.59375c3.23144-2.44727,6.41406-4.90918,9.46-7.31738l1.24023,1.56836C639.61917,745.80254,636.42484,748.27324,633.18265,750.72832Zm18.82324-14.89941-1.27734-1.53907c3.12793-2.59863,6.18652-5.21,9.09082-7.76074l1.32031,1.502C658.22171,730.59453,655.14847,733.21855,652.00589,735.82891Zm18.03223-15.86914-1.36914-1.459c2.98535-2.7998,5.86328-5.60254,8.55469-8.332l1.42382,1.4043C675.93851,714.32012,673.04105,717.14238,670.03812,719.95977Zm16.8584-17.14063-1.48828-1.33594c2.74218-3.05468,5.33593-6.11426,7.709-9.09277l1.56445,1.24609C692.28421,696.64531,689.66507,699.73516,686.89652,702.81914ZM701.84964,683.952,700.1973,682.825c2.32519-3.40723,4.42285-6.80859,6.23437-10.10938l1.75391.9629C706.34281,677.035,704.211,680.492,701.84964,683.952Zm11.5-21.21386-1.86133-.73047a69.37031,69.37031,0,0,0,3.39551-11.29l1.959.40234A71.21576,71.21576,0,0,1,713.34964,662.73809Zm2.66992-23.69629a47.10965,47.10965,0,0,0-1.60839-11.50684l1.93164-.52148a49.17317,49.17317,0,0,1,1.67675,11.99511Zm-5.98339-22.30274a60.32109,60.32109,0,0,0-6.65625-9.66406l1.5332-1.2832a62.27891,62.27891,0,0,1,6.87695,9.98632Zm-14.91993-18.10449a108.36226,108.36226,0,0,0-9.32617-7.34766l1.1543-1.63281a110.07889,110.07889,0,0,1,9.498,7.48438Zm-19.34863-13.78418c-3.27148-1.92285-6.80078-3.8418-10.4873-5.70312l.90039-1.78516c3.72558,1.87988,7.292,3.81933,10.60058,5.76367Zm-21.29687-10.81445c-3.48145-1.54688-7.18946-3.10352-11.02149-4.62793l.74024-1.85742c3.85547,1.5332,7.58789,3.10058,11.09375,4.65722ZM632.23539,565.157c-3.56348-1.292-7.37305-2.61816-11.32129-3.94141l.63476-1.89648c3.96387,1.3291,7.78906,2.66016,11.36817,3.957Zm-22.73145-7.64648c-3.48535-1.09961-7.2373-2.25684-11.47119-3.53907l.58008-1.91406c4.24072,1.28418,8.00048,2.44434,11.49267,3.54492Zm-22.979-6.99317c-4.0459-1.21-7.90332-2.36621-11.51465-3.47851l.58886-1.91211c3.60645,1.1123,7.458,2.2666,11.499,3.47461Zm-22.98389-7.1875a95.0565,95.0565,0,0,1-11.26416-4.53418l.89941-1.78711a92.76387,92.76387,0,0,0,11.019,4.43067Zm-15.103-13.11035-1.42578-1.40234c1.82324-1.85254,5.42969-3.665,11.02539-5.542l.63574,1.89649C553.45658,526.9207,550.01273,528.61992,548.438,530.21953Zm21.67676-8.30566-.4834-1.94141c3.459-.86133,7.39942-1.76269,11.71192-2.67871l.415,1.957C577.46878,520.16094,573.5513,521.05742,570.11478,521.91387Zm23.36963-5.01856-.375-1.96484c3.68506-.7041,7.65381-1.4336,11.79687-2.168l.34961,1.96875C601.12113,515.46465,597.16117,516.19219,593.48441,516.89531ZM617.05374,512.7l-.33007-1.97266q5.65283-.94775,11.83105-1.93847l.31641,1.97461Q622.69827,511.75371,617.05374,512.7Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M640.9307,508.865l-.30664-1.97656q2.9165-.45119,5.93554-.91114l.30079,1.97657Q643.84281,508.41387,640.9307,508.865Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M685.194,305.71659l9.08474-7.26606c-7.05753-.77863-9.95734,3.07039-11.14411,6.11693-5.51363-2.28947-11.51587.711-11.51587.711l18.17688,6.59885A13.75483,13.75483,0,0,0,685.194,305.71659Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M516.44078,361.96766l9.08474-7.26605c-7.05753-.77864-9.95734,3.07039-11.14411,6.11692-5.51363-2.28946-11.51587.711-11.51587.711l18.17688,6.59885A13.75487,13.75487,0,0,0,516.44078,361.96766Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M560.84953,245.51807l9.08473-7.26606c-7.05753-.77863-9.95733,3.07039-11.14411,6.11693-5.51363-2.28947-11.51587.711-11.51587.711l18.17688,6.59885A13.75484,13.75484,0,0,0,560.84953,245.51807Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M659.609,569.03965s-7.86875,0-8.74306,4.80868-2.18577,57.267-1.31146,63.82431.87431,5.24584.87431,5.24584-1.743,12.4609,2.18858,13.00631S656.5489,641.607,656.5489,641.607l3.06008-53.33264Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#9e616a"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M693.7069,569.03965s7.86875,0,8.74306,4.80868,2.18577,57.267,1.31146,63.82431-.8743,5.24584-.8743,5.24584,1.743,12.4609-2.18859,13.00631S696.767,641.607,696.767,641.607l-3.06008-53.33263Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#9e616a"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M658.29752,751.76952h-3.49721a7.86866,7.86866,0,0,0-7.86875,7.86857v.00018H668.352V749.58375H658.29752Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M691.95829,751.76952h3.49721a7.86867,7.86867,0,0,1,7.86875,7.86857v.00018H681.90377V749.58375h10.05452Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#2f2e41"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 516.09568,
    cy: 409.02131,
    r: 11.36598,
    fill: "#9e616a"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M670.53781,553.73931s-1.31146,14.426-3.06008,15.73749,18.36042-.8743,18.36042-.8743-6.99444-10.49167-5.683-13.98889S670.53781,553.73931,670.53781,553.73931Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#9e616a"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M696.32981,569.03965s-24.04341-10.05451-39.78091,0c0,0-3.93436,10.05451-.87431,15.7375s7.86875,19.23472,3.06008,28.41493.43716,5.24584.43716,5.24584-6.12014,24.48056-6.99445,43.71525,2.62293,88.30487,5.24583,88.742,10.92883,1.31146,11.80314,0,6.99444-92.67636,6.99444-92.67636,2.62292,93.55069,5.24582,93.55069,9.61737,0,10.92883-2.18577,12.24027-86.55625,8.30591-104.04235-6.55729-26.22917-6.55729-26.22917,4.80867-3.06007,3.49723-4.80869-7.86877-20.54616-4.80869-23.60625S696.32981,569.03965,696.32981,569.03965Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#2f2e41"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 523.30871,
    cy: 402.17104,
    r: 18.36042,
    fill: "#2f2e41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M691.83867,531.57749a12.36814,12.36814,0,0,1-9.33162-14.29294c-.05359.188-.104.37762-.14921.57a12.36847,12.36847,0,0,0,24.0811,5.65832c.0452-.19233.08448-.38459.12022-.57676A12.36815,12.36815,0,0,1,691.83867,531.57749Z",
    transform: "translate(-157.06503 -138.59785)",
    fill: "#2f2e41"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 535.52108,
    cy: 386.38703,
    r: 8.98489,
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDeveloper);
export default __webpack_public_path__ + "static/media/Web-developer.0621a596e61c10cbfd542eb21afcd878.svg";
export { ForwardRef as ReactComponent };